<div class="container">
  <div class="modal-header" *ngIf="!isLoading">
    <div class="device-header">
      <span>
        <i class="mdi mdi-file-document-edit-outline file-icon"></i>
        <span class="header">Configure JMEP</span>
      </span>
      <i class="mdi mdi-close close-icon" mat-dialog-close></i>
    </div>
  </div>
  <div class="loader-content" *ngIf="isLoading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Loading...</div>
    </div>
  </div>

  <div class="form-container">
    <form novalidate #jmepForm="ngForm">
      <div *ngIf="!isLoading">
        <div class="setup">
          <div class="name-row">
            <div class="name-input-field">
              <div class="label"><b>JMEP Name</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="jmepName"
                class="width100"
                [(ngModel)]="formData.name"
                #jmepNameInput="ngModel"
                [disabled]="!hasReadWriteRole"
                (ngModelChange)="validateNameChange()"
                [maxlength]="30"
                required
              />
              <div
                class="error"
                *ngIf="jmepNameInput.invalid && (jmepNameInput.dirty || jmepNameInput.touched)"
              >
                <mat-error *ngIf="jmepNameInput?.errors?.required"> Required</mat-error>
                <mat-error *ngIf="jmepNameInput.errors?.pattern"
                  >Can only use characters: a-z A-Z 0-9 ~ @ # + $ % - : . _</mat-error
                >
                <mat-error *ngIf="jmepNameInput.errors?.uniqueName">Name already used</mat-error>
              </div>
            </div>
            <div class="name-input-field field-location">
              <div class="label"><b>Location</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                class="width100"
                [(ngModel)]="formData.location"
                #nameInput="ngModel"
                [disabled]="!hasReadWriteRole"
                [maxlength]="30"
              />
            </div>
          </div>
          <div class="latitude-fields">
            <div class="latitude-field">
              <div class="label"><b>Latitude</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="lat"
                #latitudeInput="ngModel"
                [(ngModel)]="formData.lat"
                [pattern]="latitudeIPRegex"
              />
              <div
                class="error"
                *ngIf="latitudeInput.invalid && (latitudeInput.dirty || latitudeInput.touched)"
              >
                <mat-error *ngIf="latitudeInput.errors?.pattern">Invalid Latitude value</mat-error>
              </div>
            </div>
            <div class="longitude-field">
              <div class="label"><b>Longitude</b></div>
              <input
                matInput
                autocomplete="off"
                type="text"
                name="lon"
                #longitudeInput="ngModel"
                [(ngModel)]="formData.lon"
                [pattern]="longitudeIPRegex"
              />
              <div
                class="error"
                *ngIf="longitudeInput.invalid && (longitudeInput.dirty || longitudeInput.touched)"
              >
                <mat-error *ngIf="longitudeInput.errors?.pattern"
                  >Invalid Longitude value</mat-error
                >
              </div>
            </div>
          </div>
          <div class="section-container">
            <div class="left-section-data">
              <div class="header-label"><b>Management Network</b></div>
              <div class="left-section">
                <div class="input-fields">
                  <div class="label"><b>IP Address</b></div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="address"
                    class="width190"
                    [(ngModel)]="formData.address"
                    #addressInput="ngModel"
                    [disabled]="!hasReadWriteRole"
                    (ngModelChange)="validateIpAddressChange('mgmtIP')"
                  />
                  <div
                    class="error"
                    *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)"
                  >
                    <mat-error *ngIf="addressInput.errors?.regex && mgmtIpEntity?.error">
                      {{ mgmtIpEntity.error }}
                    </mat-error>
                  </div>
                </div>
                <div class="sub-section rt-arp-fields">
                  <div class="input-fields width225">
                    <div class="label"><b>ARP/NDP</b></div>
                    <mat-select
                      class="option-list"
                      #mgmtArpInput="ngModel"
                      name="mgmntArp"
                      [(ngModel)]="formData.selectedARPOption.value"
                      (ngModelChange)="onClickSelectedValues($event, 'arp')"
                      [disabled]="!hasReadWriteRole || addressIsEmpty"
                      required
                    >
                      <mat-option *ngFor="let item of ARPOptions" [value]="item.value">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                    <div class="error">
                      <mat-error
                        *ngIf="formData.selectedARPOption.value === 'disabled' && !addressIsEmpty"
                        >Communication to JMEP will be lost
                      </mat-error>
                    </div>
                  </div>
                  <div class="vlan-input-fields">
                    <div class="label">
                      <b>VLAN to terminate</b>
                      <i
                        class="icon mdi mdi-help-circle-outline"
                        matTooltip="Traffic matching this VLAN will not pass through the JMEP"
                      >
                      </i>
                    </div>
                    <input
                      matInput
                      autocomplete="off"
                      type="number"
                      name="vlan"
                      [(ngModel)]="formData.vlan"
                      #vlanInput="ngModel"
                      [disabled]="!hasReadWriteRole || addressIsEmpty"
                      class="width30"
                      min="1"
                      max="4095"
                      placeholder="1-4095"
                    />
                    <span class="sub-label">(optional)</span>
                    <div
                      class="error"
                      *ngIf="vlanInput.invalid && (vlanInput.dirty || vlanInput.touched)"
                    >
                      <mat-error *ngIf="vlanInput.errors?.min || vlanInput.errors?.max"
                        >Enter value between 1 - 4095</mat-error
                      >
                    </div>
                  </div>
                </div>
                <div class="input-fields">
                  <div class="label"><b>Ping Response</b></div>
                  <mat-select
                    class="option-list width190"
                    name="mgmtping"
                    [(ngModel)]="formData.enablePingResponse.value"
                    (ngModelChange)="onClickSelectedValues($event, 'mgmtPing')"
                    #mgmtpingInput="ngModel"
                    [disabled]="!hasReadWriteRole || addressIsEmpty"
                    required
                  >
                    <mat-option *ngFor="let item of mgmtNetworkpingResponse" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
            <div class="right-section-data">
              <div class="header-label"><b>Test Network</b></div>
              <div class="rt-section">
                <div class="input-fields">
                  <div class="label">
                    <b>IP Address</b>
                    <i
                      class="icon mdi mdi-help-circle-outline"
                      matTooltip="JMEP has TWAMP reflection enabled.  This must be disabled using the Test list before the Test IP or Test VLAN can be changed."
                    >
                    </i>
                  </div>
                  <input
                    matInput
                    autocomplete="off"
                    type="text"
                    name="ipAddress"
                    class="width190"
                    [(ngModel)]="formData.testIpAddress"
                    #testIpAddressInput="ngModel"
                    [disabled]="!hasReadWriteRole || isTestIpEditDisabled()"
                    (ngModelChange)="validateIpAddressChange('testIP')"
                  />
                  <div
                    class="error"
                    *ngIf="
                      testIpAddressInput.invalid &&
                      (testIpAddressInput.dirty || testIpAddressInput.touched)
                    "
                  >
                    <mat-error *ngIf="testIpAddressInput.errors?.regex || testIpEntity?.error">{{
                      testIpEntity.error
                    }}</mat-error>
                  </div>
                </div>
                <div class="sub-section">
                  <div class="sub-net-fields">
                    <div class="label"><b>Subnet Length</b></div>
                    <input
                      matInput
                      class="width64"
                      autocomplete="off"
                      type="text"
                      name="subnet"
                      [(ngModel)]="formData.subnet"
                      (ngModelChange)="validateSubnetChange()"
                      #subnetInput="ngModel"
                      [placeholder]="subnetLengthEntity.placeholder"
                      [disabled]="!hasReadWriteRole || testIpAddressIsEmpty"
                    />
                    <div
                      class="error"
                      *ngIf="subnetInput.invalid && (subnetInput.dirty || subnetInput.touched)"
                    >
                      <mat-error *ngIf="subnetInput.errors?.invalid">{{
                        subnetLengthEntity.error
                      }}</mat-error>
                    </div>
                  </div>
                  <div class="gateway-input-fields">
                    <div class="label"><b>Gateway IP</b></div>
                    <input
                      matInput
                      autocomplete="off"
                      type="text"
                      name="gateway"
                      class="width190"
                      [(ngModel)]="formData.gateway"
                      [disabled]="!hasReadWriteRole || testIpAddressIsEmpty"
                      #gatewayInput="ngModel"
                      (ngModelChange)="validateGatewayChange()"
                    />
                    <div
                      class="error"
                      *ngIf="gatewayInput.invalid && (gatewayInput.dirty || gatewayInput.touched)"
                    >
                      <mat-error *ngIf="gatewayInput.errors?.invalid">{{
                        gatewayEntity.error
                      }}</mat-error>
                    </div>
                  </div>
                </div>
                <div class="sub-section">
                  <div class="input-fields width225">
                    <div class="label"><b>ARP/NDP</b></div>
                    <mat-select
                      class="option-list"
                      #testArpInput="ngModel"
                      name="testARPOptions"
                      (ngModelChange)="onClickSelectedValues($event, 'testArp')"
                      [(ngModel)]="formData.selectedTestARP.value"
                      [disabled]="!hasReadWriteRole || testIpAddressIsEmpty"
                      required
                    >
                      <mat-option *ngFor="let item of testARPOptions" [value]="item.value">
                        {{ item.name }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="vlan-input-fields">
                    <div class="label">
                      <b>VLAN</b>
                      <i
                        class="icon mdi mdi-help-circle-outline"
                        matTooltip="JMEP has TWAMP reflection enabled.  This must be disabled using the Test list before the Test IP or Test VLAN can be changed."
                      >
                      </i>
                    </div>
                    <input
                      matInput
                      autocomplete="off"
                      type="number"
                      name="testVlan"
                      #testVlanInput="ngModel"
                      [(ngModel)]="formData.testVlan"
                      [disabled]="
                        !hasReadWriteRole || isTestIpEditDisabled() || testIpAddressIsEmpty
                      "
                      class="width30"
                      min="1"
                      max="4095"
                      placeholder="1-4095"
                    />
                    <span class="sub-label">(optional)</span>
                    <mat-error *ngIf="testVlanInput.errors?.min || testVlanInput.errors?.max"
                      >Enter value between 1 - 4095</mat-error
                    >
                  </div>
                </div>
                <div class="input-fields">
                  <div class="label"><b>Ping Response</b></div>
                  <mat-select
                    class="option-list width190"
                    name="testPing"
                    [(ngModel)]="formData.testNetworkpingResponse.value"
                    #testPingInput="ngModel"
                    (ngModelChange)="onClickSelectedValues($event, 'testNetworkPing')"
                    [disabled]="!hasReadWriteRole || testIpAddressIsEmpty"
                    required
                  >
                    <mat-option
                      *ngFor="let item of testNetworkpingResponseOptions"
                      [value]="item.value"
                    >
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
              </div>
            </div>
          </div>
          <div class="header-label"><b>Loopback</b></div>
          <div class="section-container">
            <div class="sub-sections">
              <div class="sub-sections-fields">
                <div class="input-fields">
                  <div class="label">
                    <b>Loopback Behavior </b>
                  </div>
                  <mat-select
                    class="option-list"
                    #testBehaviorInput="ngModel"
                    name="behavior"
                    (ngModelChange)="
                      onClickSelectedValues($event, 'behavioroption');
                      onloopbackBehaviorChange();
                      validateLoopbackFields()
                    "
                    [(ngModel)]="formData.loopbackBehavior.value"
                    [disabled]="!hasReadWriteRole"
                    required
                  >
                    <mat-option *ngFor="let item of loopbackBehaviorOptions" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="input-fields">
                  <div class="label">
                    <b>Equipment Interface</b>
                    <i
                      class="icon mdi mdi-help-circle-outline"
                      matTooltip="Source Specific Layer 2 loop requests on JMEP-3 return packets matching VLAN and source MAC; JMEP-10 only uses source MAC."
                    >
                    </i>
                  </div>
                  <mat-select
                    class="option-list"
                    #equipmentInterfaceInput="ngModel"
                    name="equipmentInterface"
                    (ngModelChange)="
                      onClickSelectedValues($event, 'equipmentInterface'); onInterfaceChange()
                    "
                    [(ngModel)]="formData.equipmentInterface.value"
                    [disabled]="!hasReadWriteRole || isDisabledLoopBackBehavior"
                    required
                  >
                    <mat-option *ngFor="let item of loopbackInterface" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="input-fields">
                  <div class="label">
                    <b>Network Interface</b>
                    <i
                      class="icon mdi mdi-help-circle-outline"
                      matTooltip="Source Specific Layer 2 loop requests on JMEP-3 return packets matching VLAN and source MAC; JMEP-10 only uses source MAC."
                    >
                    </i>
                  </div>
                  <mat-select
                    class="option-list"
                    #networkInterfaceInput="ngModel"
                    name="networkInterface"
                    (ngModelChange)="
                      onClickSelectedValues($event, 'networkInterface'); onInterfaceChange()
                    "
                    [(ngModel)]="formData.networkInterface.value"
                    [disabled]="!hasReadWriteRole || isDisabledLoopBackBehavior"
                    required
                  >
                    <mat-option *ngFor="let item of loopbackInterface" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="checkbox-field" *ngIf="!interfaceDisabled">
                  <mat-checkbox
                    [checked]="formData.enableViaviHello"
                    name="viavi"
                    [(ngModel)]="formData.enableViaviHello"
                    [disabled]="!hasReadWriteRole"
                    color="primary"
                  >
                    <div class="label">
                      <b>Respond to VIAVI Hello </b>
                    </div>
                  </mat-checkbox>
                </div>
              </div>
              <mat-error class="loop-back-msg" *ngIf="validateLoopbackFields()"
                >Enable one of the interfaces or Loopback Behavior will be set to Disabled when
                changes are applied.</mat-error
              >
            </div>
          </div>
          <div class="header-label"><b>Other</b></div>
          <div class="section-container">
            <div class="sub-sections">
              <div class="sub-sections-fields">
                <div class="input-fields">
                  <div class="label">
                    <b>802.3ah </b>
                  </div>
                  <mat-select
                    class="option-list"
                    #dyingGaspInput="ngModel"
                    name="dyingGaspOption"
                    (ngModelChange)="onClickSelectedValues($event, 'selectedDyingGaspOption')"
                    [(ngModel)]="formData.selectedDyingGaspOption.value"
                    [disabled]="!hasReadWriteRole"
                    required
                  >
                    <mat-option *ngFor="let item of dyingGaspOptions" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="input-fields">
                  <div class="label">
                    <b>Timing Mode </b>
                  </div>
                  <mat-select
                    class="option-list"
                    #timingModeInput="ngModel"
                    name="mode"
                    (ngModelChange)="onClickSelectedValues($event, 'modeOption')"
                    [(ngModel)]="formData.selectedModeOption.value"
                    [disabled]="!hasReadWriteRole"
                    required
                  >
                    <mat-option *ngFor="let item of timingMode" [value]="item.value">
                      {{ item.name }}
                    </mat-option>
                  </mat-select>
                </div>
                <div class="checkbox-field">
                  <mat-checkbox
                    [checked]="formData.enableLosPin"
                    [(ngModel)]="formData.enableLosPin"
                    name="losPin"
                    [disabled]="!hasReadWriteRole"
                    color="primary"
                  >
                    <div class="label">
                      <b>Mask LoS Pin </b>
                    </div>
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div *ngIf="!isLoading">
    <div class="btn-group btn-align">
      <button
        mat-flat-button
        class="save-btn"
        [disabled]="!form.valid || disableAction"
        (click)="saveConfigDetails()"
      >
        APPLY
      </button>
      <button mat-button class="save-btn cancel" mat-dialog-close>CANCEL</button>
    </div>
  </div>
</div>
